export default {
    users: [],
    productionDepartments: [],
    stopCardProductionDepartments: [],
    machines: [],
    usersLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters,
    squads: [],
    positions: [],
    roles: []
}

function setInitialFilters() {
    return {
        search: null,
        productionDepartment_id: null
    }
}
